import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import { useHistory } from 'react-router';

import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import ButtonComp from '../button';
// import './servicestyles.css';
import { CommonConfig } from '../../config/common-config';
import token from '../../config/token';
import LoaderPopUp from '../loaderpopup/loader';
import SuccessPopUp from '../loaderpopup/success';
import ErrorPopUp from '../loaderpopup/error';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    disflx: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    button: {
        textTransform: 'capitalize !important',
        fontSize: '13px !important',
        fontWeight: '500 !important',
        boxShadow: 'none !important',
        height: '35px',
        borderRadius: '6px',
        '&:hover': {
            backgroundColor: '#3f51b5',
        },
    }
});

export default function ViewRazorPay(props) {
    const tokens = token();
    const classes = useStyles();
    const history = useHistory();
    const [totalElements, setTotalElements] = useState('');
    const [rpinfo, setrpinfo] = useState('');

    const [showLoader, setShowLoader] = useState(false);
    const [errormsg, setErrormsg] = useState('');
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    // const vertical = 'top';
    // const horizontal = 'center';
    const [catchErrorDiv, setCatchErrorDiv] = useState('none');
    const menuContents = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userType = menuContents.result && menuContents.result.data.userType;

    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);

    const dbname = tennantDetails.tennantName;
    const apiUrlIMC = `${CommonConfig.dev.baseUrl}/api/auth/razorpay/${dbname}`;
    const apiUrlIteC = `${CommonConfig.dev.baseUrl}/api/auth/razorpay`;
    const apiTypeUrl = userType === 'SUPERADMIN' ? apiUrlIteC : apiUrlIMC;

    const [razorpayIsActive, setRazorpayIsActive] = React.useState(true);
    const handleChange = (event) => {
        setRazorpayIsActive(event.target.checked);
    };

    const cancelFunc = () => {
        history.push('/menu');
    };

    const handleClose = () => {
        setShowLoader(false);
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            description: rpinfo.description || '',
            apiKey: rpinfo.apiKey || '',
            secretKey: rpinfo.secretKey || '',
            displayName: rpinfo.displayName || '',
        },

        validationSchema: Yup.object().shape({
            description: Yup.string().required('Required '),
            apiKey: Yup.string().required('Required '),
            displayName: Yup.string().required('Required '),
            secretKey: Yup.string().required('Required '),
        }),
        onSubmit: (values) => {
            setShowLoader(true);

            const updateDataArr = { ...values, id: rpinfo.id, razorpayIsActive };
            const createNewArr = { ...values, razorpayIsActive };

            if (totalElements === 0) {
                axios
                    .post(apiTypeUrl, createNewArr, tokens)
                    .then((response) => {
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            setSuccessPop(false);
                        }, 3000);
                    })
                    .catch((error) => {
                        const errResult = error.response;
                        if (errResult.data) {
                            setShowLoader(false);
                            setErrorPop(true);
                            setTimeout(() => {
                                setErrorPop(false);
                            }, 5000);
                            setErrorMsgGenerateRecceipt(errResult.data.message);
                            setCatchErrorDiv('block');
                        }
                    });
            }
            if (totalElements > 0) {
                axios
                    .put(apiTypeUrl, updateDataArr, tokens)
                    .then((response) => {
                        setCatchErrorDiv('none');
                        setShowLoader(false);
                        setSuccessPop(true);
                        setTimeout(() => {
                            setSuccessPop(false);
                        }, 3000);
                    })
                    .catch((error) => {
                        const errResult = error.response;
                        if (errResult.data) {
                            setShowLoader(false);
                            setErrorPop(true);
                            setTimeout(() => {
                                setErrorPop(false);
                            }, 5000);
                            setErrorMsgGenerateRecceipt(errResult.data.message);
                            setCatchErrorDiv('block');
                        }
                    });
            }
        },
    });

    useEffect(() => {
        axios
            .get(apiTypeUrl, tokens)
            .then((response) => {
                if (response.data.totalElements > 0) {
                    setrpinfo(response.data.content[0]);
                    setTotalElements(response.data.totalElements);
                } else {
                    setrpinfo([]);
                    setTotalElements(response.data.totalElements);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    }, [tokens, userType, apiTypeUrl]);

    return (
        <>
            {/* <Snackbar
                className="deleteError"
                open={updateStat}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={() => {
                    setUpdateStat(false);
                }}
            >
                <Alert
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    updated successfully
                </Alert>
            </Snackbar> */}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Updated successfully" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null}

            <form className="itecform" onSubmit={formik.handleSubmit}>
                <Card className="clientcard">
                    <CardContent className="client-heading">
                        <div className={classes.disflx}>
                            <div>
                                <Typography variant="h5">Razorpay</Typography>
                            </div>
                            <div>
                                <FormControlLabel
                                    style={{ marginTop: '-8px' }}
                                    control={
                                        <Switch
                                            checked={razorpayIsActive}
                                            onChange={handleChange}
                                            name="razorpayIsActive"
                                            color="primary"
                                        />
                                    }
                                    label={razorpayIsActive ? "Enabled" : "Disabled"}
                                />
                            </div>
                        </div>
                    </CardContent>

                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="apikey" shrink>
                                        Api Key
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Enter Api Key"
                                        name="apiKey"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.apiKey}
                                    />

                                    {formik.touched.apiKey && formik.errors.apiKey ? (
                                        <span className="itec-validationError">{formik.errors.apiKey}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="secretKey" shrink>
                                        secretKey
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="secretKey"
                                        name="secretKey"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.secretKey}
                                    />
                                    {formik.touched.secretKey && formik.errors.secretKey ? (
                                        <span className="itec-validationError">{formik.errors.secretKey}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="displayname" shrink>
                                        Display Name
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Enter Name"
                                        name="displayName"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.displayName}
                                    />
                                    {formik.touched.displayName && formik.errors.displayName ? (
                                        <span className="itec-validationError">{formik.errors.displayName}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="description" shrink>
                                        Description
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        className="bottom"
                                        placeholder="Enter Description"
                                        name="description"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.description}
                                    />
                                    {formik.touched.description && formik.errors.description ? (
                                        <span className="itec-validationError">{formik.errors.description}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <div style={{ display: catchErrorDiv }}>
                    <div className="errorMsgRed">{errormsg}</div>
                </div>
                <div className="createintermediary-btndiv">
                    <ul style={{ listStyle: 'none', paddingLeft: '2px' }}>
                        <li style={{ display: 'inline-block' }}>
                            <Button className={classes.button}
                                variant="contained"
                                onClick={cancelFunc} color="primary">
                                Back
                            </Button>
                        </li>
                        <li style={{ display: 'inline-block', paddingLeft: '10px' }}>
                            {(showLoader ? (
                                <LoaderPopUp showLoader={showLoader} handleClose={handleClose} title="Please wait while we save data" />
                            ) : null) ||
                                <ButtonComp type="submit" className="intermediarybutn" title="Save" />}
                        </li>
                    </ul>
                </div>
            </form>
        </>
    );
}
